// removed by extract-text-webpack-plugin
module.exports = {"parentDiv":"SideDrawer__parentDiv__fK6Cl"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/SideDrawer/SideDrawer.css
// module id = 328
// module chunks = 0